import { css } from 'styled-components';

const Resets = css`
  body {
    overflow-x: hidden;
    &.journey--overflowYHidden {
      overflow-y: hidden !important;
    }
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: ${({ theme }) => theme.font.family.body};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.base};
  }

  a {
    text-decoration: none;
  }

  ::part(input),
  ::part(label),
  ::part(hint) {
    letter-spacing: -0.03em;
  }
`;

export default Resets;
